import { LeftSquareTwoTone, EyeOutlined, PlusCircleOutlined, FilterOutlined, UserOutlined } from '@ant-design/icons'
import { Breadcrumb, Button, Col, DatePicker as AntDatePicker, message, Row, Table, Tag, Space, Tooltip, List, Typography } from 'antd'
import Avatar from 'antd/lib/avatar/avatar'
import TextArea from 'antd/lib/input/TextArea'
import Modal from 'antd/lib/modal/Modal'
import moment from 'moment'
import React from 'react'
import { connect } from 'react-redux'
import {
  createAdminOrSubAdmin,
  findCustomerWithPhoneNumbers,
  getCustomers,
  addNote,
  getNotes,
} from '../../RestServices/authService'
import { formateString, PermissionEnum } from '../../shared'
import { fontColor, MAIN_BACKGROUND_COLOR } from '../../styleConstants'
import ContantTitle from '../../utils/contantTitle/ContantTitle'
import '../Dashboard/styles.css'
import Pagination from '../Pagination'
import AddUserModal from './AddUser'

//
// import Table from "../Table";

const styles = {
  layout: {
    minHeight: '100vh',
  },
  header: {
    backgroundColor: MAIN_BACKGROUND_COLOR,
    padding: 0,
  },
  sider: {
    backgroundColor: MAIN_BACKGROUND_COLOR,
  },
  menu: {
    backgroundColor: MAIN_BACKGROUND_COLOR,
    color: fontColor,
    fontWeight: 'bold',
  },
  content: {
    color: fontColor,
    backgroundColor: 'white',
    margin: '20px',
  },
  logo: {
    height: '200px',
    width: '190px',
  },
  menuToggler: {
    color: fontColor,
    fontSize: '30px',
    marginLeft: '5px',
    marginTop: '15px',
  },

  tableContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  addUserButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  addUserButton: {
    marginRight: '20px',
    backgroundColor: '#1f910e',
    color: 'white',
  },
}
const columns = [
  {
    Header: 'Name',
    accessor: 'name',
  },
  {
    Header: 'Email',
    accessor: 'email', // accessor is the "key" in the data
  },
  {
    Header: 'Role',
    accessor: 'type',
  },
  {
    Header: 'Status',
    accessor: 'status', // accessor is the "key" in the data
  },
]

// `null`/missing means the member never opened the app (the "Idol" bucket).
// moment(null) renders "Invalid date" and moment(undefined) silently
// resolves to "now" — neither is what we want to show, so make the
// "never opened" case explicit instead of leaking either quirk into the UI.
const formatLastSeen = (lastProfileFetched) =>
  lastProfileFetched ? moment(lastProfileFetched).format(formateString) : 'Never'

// Small, reusable color maps so "Rule"/"Status" read as tags at a glance
// instead of plain text — shared by every render() call on those columns.
const RULE_TAG_COLORS = {
  UPGRADED: 'blue',
  INITIAL: 'default',
  ADMIN: 'purple',
  SUBADMIN: 'purple',
}
const STATUS_TAG_COLORS = {
  LOGGED_IN: 'green',
  LOGGED_OFF: 'default',
  BLOCKED: 'red',
}

// `slectedSubkey` doubles as both the raw `type` value sent to the
// getAllCustomers API and (previously) the on-screen label — that's why the
// breadcrumb/heading showed the literal key "today_active" instead of a
// human label. Map it to a display label here without touching the value
// used for the API call.
const SUBKEY_LABELS = {
  today_active: 'Daily Active',
  Active: 'Active',
  Sluggish: 'Sluggish',
  Idol: 'Idol',
  'Total Members': 'Total Members',
}
const displaySubkeyLabel = (key) => SUBKEY_LABELS[key] || key

class Users extends React.Component {
  constructor(props) {
    super(props);
    // Seed the date filter from the home dashboard's From/To range (passed
    // through Dashboard/index.js -> AppUser as `data`) so the drill-down
    // list starts out matching the range the card counted, instead of
    // defaulting to "no filter" (which returned every record).
    const seededRange =
      props.data && props.data.startDate && props.data.endDate
        ? { startDate: props.data.startDate, endDate: props.data.endDate }
        : { startDate: undefined, endDate: undefined };

    this.state = {
      collapsed: false,
      input: null,
      isFormLoading: false,
      isLoading: false,
      customers: [],
      totalPages: 1,
      selectedRowKeys: [],
      currentPage: 1,
      metaData: {},
      isModalOpen: false,
      name: '',
      data: {},
      email: '',
      password: '',
      permissions: [],
      type: 'ADMIN',
      city: '',
      selectedUser: {},
      rawCustomer: [],
      phoneNumber: '',
      datesBetween: {
        ...seededRange,
      },
      isModalVisible: false,
      phoneNumberText: '',
      getPhoneListLoading: false,
      ListUser: null,
      screenSwitch: false,
      noteModalVisible: false,
      noteType: 'view', // 'view' or 'add'
      currentNote: '',
      notesHistory: [],
      loadingNotes: false,
      activeCustomer: null,
    };
  }

  onChangePermission = (permissions) => {
    this.setState({ permissions })
  }
  toggleSider = () => {
    this.setState({ collapsed: !this.state.collapsed })
  }
  inputEvent = (e) => {
    this.setState({ input: e.target.value })
    console.log(e.target.value)
  }
  inputHandler = (evt) => {
    const { name, value } = evt.target
    this.setState({ [name]: value })
  }
  openUserShowDetailModal = () => this.setState({ isModalOpen: true })
  closeUserShowDetailModal = () => this.setState({ isModalOpen: false })

  resetForm = () =>
    this.setState({
      name: '',
      email: '',
      password: '',
      city: '',
      phoneNumber: '',
      permissions: [],
    })
  submitForm = async (evt) => {
    evt.preventDefault()
    const { name, email, password, phoneNumber, city, type, permissions } =
      this.state
    if (!name || !email || !password || !phoneNumber || !city || !type) {
      return message.error('Please fill all value ')
    }
    if (!permissions.length) {
      return message.error('Please check the some permission')
    }

    console.log(this.state, permissions)
    this.setState({ isFormLoading: true })
    try {
      const data = await createAdminOrSubAdmin(
        { ...this.state, permissions },
        this.props.Auth.user.token,
      )

      const customer = {
        name: data.customer.name,
        email: data.customer.email,
        key: data.customer._id,
        updatedAt: new Date().toISOString(),
        type: data.customer.profileDetails.type,
        status: data.customer.status,
        phoneNumber: data.customer.phoneNumber,
      }
      this.setState({
        isFormLoading: false,
        isModalOpen: false,
        customers: [customer, ...this.state.customers],
      })
      message.success('User ' + data.customer.name + ' Created!')
      this.resetForm()
    } catch (err) {
      this.setState({ isFormLoading: false })
      if (err.response) {
        return message.error(err.response.data.message)
      }
      return message.error(err.message)
    }
  }

  getUserApiFunc = async () => {
    this.setState({ isLoading: true })
    try {
      let data = await getCustomers(this.props.Auth.user.token, {
        page: this.state.currentPage,
        type: this.props.slectedSubkey,
        startDate: this.state.datesBetween.startDate
          ? moment(this.state.datesBetween.startDate).toDate()
          : undefined,
        endDate: this.state.datesBetween.endDate
          ? moment(this.state.datesBetween.endDate).toDate()
          : undefined,
      })
      // console.log(data, "data");
      const customers = data.customers.docs.map((customer) => ({
        name: customer.name,
        type: customer.profileDetails.type,
        status: customer.status,
        key: customer._id,
        // `lastProfileFetched` is null/missing for members who never opened
        // the app (that's what makes them "Idol") — moment(null/undefined)
        // doesn't reliably format as empty (moment(undefined) silently
        // resolves to "now"), so make the "never opened" case explicit here
        // instead of showing a misleading timestamp.
        updatedAt: formatLastSeen(customer.lastProfileFetched),
        createdAt: moment(customer.createdAt).format(formateString),

        phoneNumber: customer.phoneNumber,
        profileImage: customer.profileImage,
        city: customer.city,
      }))
      this.setState({
        customers,
        currentPage: data.customers.page,
        totalPages: data.customers.totalDocs,
        rawCustomer: data.customers.docs,
        data: data.customers,
      })
    } catch (err) {
      if (err.response) {
        return message.error(err.response.data.message)
      }
      return message.error(err.message)
    } finally {
      this.setState({ isLoading: false })
    }
  }
  componentDidMount() {
    this.getUserApiFunc()
  }

  tableColumns = [
    {
      title: 'Sr.',
      width: 56,
      dataIndex: 'index',
      fixed: 'left',
      align: 'center',
      render: (text, record, index) =>
        (this.state.currentPage - 1) * 20 + index + 1,
    },
    {
      title: 'Image',
      width: 64,
      dataIndex: 'profileImage',
      fixed: 'left',
      align: 'center',
      render: (text) => (
        <Avatar
          size={36}
          src={text || undefined}
          icon={!text && <UserOutlined />}
          style={!text ? { backgroundColor: '#fb6222' } : undefined}
        />
      ),
    },
    {
      key: 'name',
      title: 'Name',
      dataIndex: 'name',
      render: (text) => text || <Typography.Text type="secondary">—</Typography.Text>,
    },

    {
      key: 'phoneNumber',
      title: 'Phone',
      dataIndex: 'phoneNumber',
      render: (text) =>
        text ? (
          <a style={{ color: '#1890ff' }} href={`tel:${text}`}>
            {text}
          </a>
        ) : (
          <Typography.Text type="secondary">—</Typography.Text>
        ),
    },
    {
      key: 'city',
      title: 'City',
      dataIndex: 'city',
      render: (text) => text || <Typography.Text type="secondary">—</Typography.Text>,
    },

    {
      key: 'type',
      title: 'Rule',
      dataIndex: 'type',
      render: (text) => <Tag color={RULE_TAG_COLORS[text] || 'default'}>{text || '—'}</Tag>,
    },

    {
      key: 'status',
      title: 'Status',
      dataIndex: 'status',
      render: (text) => <Tag color={STATUS_TAG_COLORS[text] || 'default'}>{text || '—'}</Tag>,
    },
    {
      key: 'createdAt',
      title: 'Date of Creation',
      dataIndex: 'createdAt',
    },

    {
      key: 'updatedAt',
      title: 'Last Seen',
      dataIndex: 'updatedAt',
    },
    {
      key: 'actions',
      title: 'Actions',
      width: 120,
      render: (text, record) => (
        <Space size="middle">
          <Tooltip title="View Notes">
            <Button
              shape="circle"
              icon={<EyeOutlined style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} />}
              onClick={() => this.openNoteModal(record, 'view')}
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            />
          </Tooltip>
          <Tooltip title="Add Note">
            <Button
              shape="circle"
              type="primary"
              icon={<PlusCircleOutlined style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} />}
              onClick={() => this.openNoteModal(record, 'add')}
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            />
          </Tooltip>
        </Space>
      ),
    },
  ]

  openNoteModal = (customer, type) => {
    this.setState({
      noteModalVisible: true,
      noteType: type,
      activeCustomer: customer,
      currentNote: '',
    }, () => {
      if (type === 'view') {
        this.fetchNotes(customer.key)
      }
    })
  }

  fetchNotes = async (customerId) => {
    this.setState({ loadingNotes: true })
    try {
      const response = await getNotes(customerId, this.props.Auth.user.token)
      this.setState({ notesHistory: response.notes || [], loadingNotes: false })
    } catch (err) {
      message.error('Failed to fetch notes')
      this.setState({ loadingNotes: false })
    }
  }

  handleSaveNote = async () => {
    const { currentNote, activeCustomer } = this.state
    if (!currentNote.trim()) {
      return message.error('Please enter a note')
    }

    try {
      await addNote({
        customerId: activeCustomer.key,
        note: currentNote,
        adminId: this.props.Auth.user._id,
      }, this.props.Auth.user.token)

      message.success('Note added successfully')
      this.setState({ noteModalVisible: false, currentNote: '' })
    } catch (err) {
      message.error('Failed to add note')
    }
  }

  closeNoteModal = () => {
    this.setState({ noteModalVisible: false, notesHistory: [] })
  }

  onPageChange = (page) => {
    this.setState({ currentPage: page }, () => {
      this.getUserApiFunc()
    })
  }

  showModal = () => {
    this.setState({ isModalVisible: true })
  }

  handleOk = () => {
    this.setState({ isModalVisible: false })
  }

  handleCancel = () => {
    this.setState({ isModalVisible: false, screenSwitch: false })
  }

  // Single antd RangePicker drives the filter — same component/pattern as
  // the home dashboard's From/To range, instead of the old react-date-range
  // dropdown (broken static-ranges panel that overlapped the page content).
  handleRangeChange = (range) => {
    if (!range || !range[0] || !range[1]) return
    this.setState(
      {
        currentPage: 1,
        datesBetween: {
          startDate: range[0].toDate(),
          endDate: range[1].toDate(),
        },
      },
      () => this.getUserApiFunc(),
    )
  }

  rowSelection = {
    onChange: (selectedRowKeys) => {
      const [id] = selectedRowKeys
      const selectedUser = this.state.rawCustomer.find((user) => user.id === id)
      console.log(selectedUser)
      this.setState({ selectedRowKeys, selectedUser })
      this.openUserShowDetailModal()
    },
  }

  onChange = ({ target: { value } }) => {
    this.setState({ phoneNumberText: value })
  }
  fetchUserData = async () => {
    try {
      const { phoneNumberText } = this.state
      let payload = phoneNumberText.split('\n')

      payload = payload.filter(function (el) {
        return el != ''
      })

      this.setState({ getPhoneListLoading: true })
      const response = await findCustomerWithPhoneNumbers(
        this.props.Auth.user.token,
        { phoneNumbers: payload },
      )
      this.setState({
        listUser: response.customerList,
        screenSwitch: true,
      })
      console.log(response)
    } catch (err) {
      console.log(err)
    } finally {
      this.setState({ getPhoneListLoading: false })
    }
  }
  render() {
    const {
      customers,

      totalPages,
      currentPage,

      isFormLoading,
      isLoading,
    } = this.state

    const { permissions: userPermission } = this.props.Auth.user.profileDetails

    return (
      <div style={styles.content}>
        <Modal
          title="Filter Phone Number"
          visible={this.state.isModalVisible}
          onOk={this.handleOk}
          width={window.innerWidth < 768 ? '95%' : '70%'}
          height="80vh"
          onCancel={this.handleCancel}
        >
          <Row justify="center" align="middle" gutter={[16, 16]}>
            {!this.state.screenSwitch ? (
              <Col xs={24} sm={18} md={12}>
                <p>Enter phone numbers</p>
                <TextArea
                  style={{ width: '100%' }}
                  value={this.state.phoneNumberText}
                  onChange={this.onChange}
                  placeholder="Controlled autosize"
                  autoSize={{ minRows: 3, maxRows: 15 }}
                />
                <Button
                  loading={this.state.getPhoneListLoading}
                  onClick={this.fetchUserData}
                  style={{ marginTop: '20px' }}
                  type={'primary'}
                  block={window.innerWidth < 768}
                >
                  Get Result
                </Button>
              </Col>
            ) : (
              <Col span={24}>
                <Row gutter={[12, 12]}>
                  <Col xs={24} sm={12}>
                    <p>Users Number</p>
                    <TextArea
                      style={{ width: '100%' }}
                      value={this.state.listUser?.customerList
                        ?.map((value) => value.phoneNumber)
                        ?.join('\n')}
                      // onChange={this.onChange}
                      placeholder="User"
                      autoSize={{ minRows: 3, maxRows: 15 }}
                    />
                  </Col>
                  <Col xs={24} sm={12}>
                    <p>Non Users Number</p>
                    <TextArea
                      style={{ width: '100%' }}
                      value={this.state.listUser?.notPresents?.join('\n')}
                      // onChange={this.onChange}
                      placeholder="Non User"
                      autoSize={{ minRows: 3, maxRows: 15 }}
                    />
                  </Col>
                </Row>
              </Col>
            )}
          </Row>
        </Modal>
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={2} md={1}>
            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
               <LeftSquareTwoTone
                onClick={() => this.props.setSelected('Dashboard')}
                style={{
                  fontSize: '28px',
                  color: 'red',
                  margin: '10px 0',
                  cursor: 'pointer',
                }}
              />
            </div>
          </Col>
          <Col xs={24} sm={10} md={7}>
            <Breadcrumb style={{ margin: '8px 0', cursor: 'pointer', fontSize: '16px' }}>
              <Breadcrumb.Item>Admin Dashboard</Breadcrumb.Item>
              <Breadcrumb.Item>{displaySubkeyLabel(this.props.slectedSubkey)}</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Button
              onClick={this.showModal}
              icon={<FilterOutlined />}
              block
              size="large"
              style={{
                marginBottom: window.innerWidth < 768 ? '8px' : '0',
                color: '#fb6222',
                borderColor: '#fb6222',
                fontWeight: 500,
              }}
            >
              Filter Phone Number
            </Button>
          </Col>
          <Col xs={24} md={10}>
            <div style={{
              display: 'flex',
              justifyContent: window.innerWidth < 768 ? 'center' : 'flex-end',
              width: '100%'
            }}>
              <AntDatePicker.RangePicker
                value={
                  this.state.datesBetween.startDate && this.state.datesBetween.endDate
                    ? [moment(this.state.datesBetween.startDate), moment(this.state.datesBetween.endDate)]
                    : null
                }
                allowClear={false}
                format="MMM DD, YYYY"
                size="large"
                style={{ width: '100%', maxWidth: '340px' }}
                disabledDate={(d) => d && d > moment().endOf('day')}
                ranges={{
                  Today: [moment(), moment()],
                  'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                  'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                  'This Month': [moment().startOf('month'), moment()],
                }}
                onChange={this.handleRangeChange}
              />
            </div>
          </Col>
        </Row>
        {(userPermission.includes(PermissionEnum['AllResources:*']) ||
          userPermission.includes(PermissionEnum['Users:*']) ||
          userPermission.includes(PermissionEnum['Users:add'])) && (
            <ContantTitle
              heading={
                displaySubkeyLabel(this.props.slectedSubkey) +
                ' Users (' +
                (isLoading ? '…' : this.state.data?.totalDocs ?? 0) +
                ')'
              }
              // buttonText={"Add User"}
              openForm={console.log}
            />
          )}
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            marginBottom: '12px',
            padding: '8px 14px',
            background: '#fafafa',
            border: '1px solid #f0f0f0',
            borderRadius: '8px',
          }}
          className="pagination-container"
        >
          <Pagination
            current={currentPage}
            total={totalPages}
            onPageChange={this.onPageChange}
          />
        </div>
        <Table
          dataSource={customers}
          pagination={false}
          columns={this.tableColumns}
          scroll={{ x: 'max-content' }}
          loading={isLoading}
          bordered
          size="middle"
          sticky
          rowSelection={{
            type: 'radio',
            selectedRowKeys: this.state.selectedRowKeys,
            ...this.rowSelection,
          }}
        />

        <AddUserModal
          selectedUser={this.state.selectedUser}
          submitForm={this.closeUserShowDetailModal}
          isFormLoading={isFormLoading}
          isOpen={this.state.isModalOpen}
          closeModal={this.closeUserShowDetailModal}
          inputHandler={this.inputHandler}
        />

        <Modal
          title={this.state.noteType === 'view' ? "Notes History" : "Add New Note"}
          visible={this.state.noteModalVisible}
          onCancel={this.closeNoteModal}
          footer={[
            <Button key="back" onClick={this.closeNoteModal}>
              Close
            </Button>,
            this.state.noteType === 'add' && (
              <Button key="submit" type="primary" onClick={this.handleSaveNote}>
                Save Note
              </Button>
            ),
          ]}
          width={600}
        >
          {this.state.noteType === 'add' ? (
            <div>
              <Typography.Text strong>Adding note for: {this.state.activeCustomer?.name}</Typography.Text>
              <TextArea
                rows={4}
                value={this.state.currentNote}
                onChange={(e) => this.setState({ currentNote: e.target.value })}
                placeholder="Enter note details here..."
                style={{ marginTop: '10px' }}
              />
            </div>
          ) : (
            <List
              loading={this.state.loadingNotes}
              itemLayout="horizontal"
              dataSource={this.state.notesHistory}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta
                    title={
                      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography.Text strong>{item.adminId?.name || 'Admin'}</Typography.Text>
                        <Typography.Text type="secondary" style={{ fontSize: '12px' }}>
                          {moment(item.date).format('lll')}
                        </Typography.Text>
                      </div>
                    }
                    description={item.note}
                  />
                </List.Item>
              )}
              locale={{ emptyText: 'No notes found for this user' }}
            />
          )}
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  Auth: store.Authentication,
})
export default connect(mapStateToProps)(Users)
